import { FunctionComponent, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { DefaultTheme, ThemeProvider } from 'styled-components';
import { NotificationProvider } from 'components/elements';
import { getSystemTheme } from 'store/system';
import { GlobalStyle } from 'styles';
import { dark, light } from 'styles/themes';
import { AppThemeProviderProps } from './types';

export const AppThemeProvider: FunctionComponent<AppThemeProviderProps> = props => {
  const { children, notification$ } = props;

  // Retrieve system configuration
  const variant = useSelector(getSystemTheme);

  // Pick theme object based on the configuration value
  const theme = useMemo<DefaultTheme>(() => {
    switch (variant) {
      case 'dark':
        return dark;
      case 'light':
      default:
        return light;
    }
  }, [variant]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <NotificationProvider value={notification$}>{children}</NotificationProvider>
    </ThemeProvider>
  );
};
